/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import Footer from "examples/Footer";
// EmployeeView page components
import BaseLayout from "layouts/pages/account/components/BaseLayout";
import { useEffect, useMemo, useRef, useState } from "react";
import ApiCalls from "services/flick_erp_api_call";
import { useLocation, useNavigate } from "react-router-dom";
import {
	AccountBalanceWalletRounded,
	AccountCircle,
  Assignment,
  DescriptionOutlined,
  Edit,
  Email,
  Inventory,
  Lock,
  Person,
  Phone,
  PlaceOutlined,
  Security,
  WorkOutline,
} from "@mui/icons-material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Documents from "./components/Documents";
import BasicInfo from "./components/BasicInfo";
import ChangePassword from "./components/ChangePassword";
import Permissions from "./components/Permissions";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Avatar, Card, IconButton } from "@mui/material";
import ContractView from "./components/Contract";
import Details from "./components/Details";
import MDTypography from "components/MDTypography";
import SystemDetails from "./components/SystemDetails";
import colors from "assets/theme/base/colors";
import rgba from "assets/theme/functions/rgba";
import { base_url } from "services";
import MDAvatar from "components/MDAvatar";
import { LeaveBalance } from "./components/LeaveBalance";

function EmployeeView({ userid, permissions, modulePermissions }) {
  const location = useLocation();
  const [isReloadRequest, setIsReloadRequest] = useState(false);
	const [branch, setBranch] = useState([]);
	const [selectedImage, setSelectedImage] = useState(null);

  const loggedUser = JSON.parse(localStorage.getItem("user"));
  const user_id = location.state?.userid ?? loggedUser.employee_id;
  const permission = location.state?.permissions ?? permissions;
  const isCreateEmployee = location.state?.isCreateEmployee;

  const navigate = useNavigate();
  useEffect(() => {
    isCreateEmployee == undefined ? getEmployee() : null;
  }, [user_id,isReloadRequest]);
  useEffect(() => {
    getBranch();
  }, []);
  const [data, setData] = useState(null);

  const [tabComponents, setTabComponents] = useState([]);
  const [employee, setEmployee] = useState({
    gender: { id: "m", name: "Male" },
  });

  const user = JSON.parse(localStorage.getItem("user"));

  const normalizeImage = (image) => {
    if (!image) return "";
    return image.startsWith("http") ? image : `${base_url}${image}`;
  };

  const currentBranchName = useMemo(() => {
    const selectedBranch = branch.find(
      (item) => String(item.id) === String(data?.branch)
    );
    return data?.branch_name || selectedBranch?.name || "No branch assigned";
  }, [branch, data?.branch, data?.branch_name]);

  async function getEmployee() {
    var res = await ApiCalls.getEmployee(user_id);
    if (res.success && res.code == 200) {
      setData(res.data);
    }
  }

		async function getBranch() {
			var res = await ApiCalls.getBranch();
			if (res.success && res.code == 200) {
				setBranch(res.data);
			} else {
			}
		}


  useEffect(() => {
    setTabComponents([
      {
        label: "Profile",
        component: (
          <BasicInfo
            data={data}
						branch={branch}
            isCreateEmployee={isCreateEmployee}
            Employee={employee}
            setEmployee={setEmployee}
            permissions={permission}
            modulePermissions={modulePermissions}
            setIsReloadRequest={setIsReloadRequest}
            reloadCallback = {()=>{
              getEmployee()
            }}
          />
        ),
        icon: <Person />,
        visible: true,
      },
      {
        label: "Password",
        component: (
          <ChangePassword
            data={data}
            isCreateEmployee={isCreateEmployee}
            Employee={employee}
            setEmployee={setEmployee}
            permissions={permission}
            modulePermissions={modulePermissions}
          />
        ),
        icon: <Lock />,
        visible: permissions?.includes(modulePermissions.update_permission)
          ? true
          : user_id == user.employee_id
          ? true
          : false ?? false,
      },
      {
        label: "Leave Balance",
        component: (
					<LeaveBalance
						permissionKey="leave"
						data={data}
						isCreateEmployee={isCreateEmployee}
						Employee={employee}
						setEmployee={setEmployee}
						permissions={permissions}
						modulePermissions={modulePermissions}
						setIsReloadRequest={setIsReloadRequest}
					/>
        ),
        icon: <Inventory />,
        visible:
          permissions?.includes(modulePermissions.update_permission) ?? false,
      },
      {
        label: "Permissions",
        component: (
          <Permissions
            data={data}
            isCreateEmployee={isCreateEmployee}
            Employee={employee}
            setEmployee={setEmployee}
            permissions={permission}
            modulePermissions={modulePermissions}
          />
        ),
        icon: <Security />,
        visible:
          permissions?.includes(modulePermissions.update_permission) ?? false,
      },
      // {
      //   label: "Managers",
      //   component: (
      //     <ReportingManager
      //       data={data}
      //       isCreateEmployee={isCreateEmployee}
      //       Employee={employee}
      //       setEmployee={setEmployee}
      //       permissions={permission}
      //       modulePermissions={modulePermissions}
      //       reloadCallback = {(v)=>{
      //         getEmployee()
      //       }}
      //     />
      //   ),
      //   icon: <Badge />,
      //   visible: (permissions?.includes(modulePermissions.reporting_structure_owner_list_permission) || permissions?.includes(modulePermissions.reporting_structure_list_permission)) ?? false,
      // },
      // {
      //   label: "Leave Balance",
      //   component: (
      //     <LeaveBalance

      //       permissionKey="leave"
      //       data={data}
      //       isCreateEmployee={isCreateEmployee}
      //       Employee={employee}
      //       setEmployee={setEmployee}
      //       permissions={permission}
      //       modulePermissions={modulePermissions}
      //       setIsReloadRequest={setIsReloadRequest}
      //     />
      //   ),
      //   icon: <Comment />,
      //   visible:
      //     permissions?.includes(modulePermissions.update_permission) ?? false,
      // },
      {
        label: "Documents",
        component: (
          <Documents
            data={data}
            isCreateEmployee={isCreateEmployee}
            Employee={employee}
            setEmployee={setEmployee}
            permissions={permission}
            modulePermissions={modulePermissions}
          />
        ),
        icon: <Assignment />,
        visible:
          permissions?.includes(modulePermissions.update_permission) ?? false,
      },
      {
        label: "Contracts",
        component: (
          <ContractView
            data={data}
            isCreateEmployee={isCreateEmployee}
            Employee={employee}
            setEmployee={setEmployee}
            permissions={permission}
            modulePermissions={modulePermissions}
          />
        ),
        icon: <DescriptionOutlined />,
        visible:
          permissions?.includes(modulePermissions.update_permission) ?? false,
      },
      {
        label: "System Details",
        component: (
          <SystemDetails
            data={data}
            isCreateEmployee={isCreateEmployee}
            Employee={employee}
            setEmployee={setEmployee}
            permissions={permission}
            modulePermissions={modulePermissions}
          />
        ),
        icon: <WorkOutline />,
        visible:
          permissions?.includes(modulePermissions.update_permission) ?? false,
      },
      // {
      //   label: "Bank Details",
      //   component: (
      //     <BankDetails
      //       data={data}
      //       isCreateEmployee={isCreateEmployee}
      //       Employee={employee}
      //       setEmployee={setEmployee}
      //       permissions={permission}
      //       modulePermissions={modulePermissions}
      //     />
      //   ),
      //   icon: <AccountBalance />,
      //   visible:
      //     permissions?.includes(modulePermissions.update_permission) ?? false,
      // },
    ]);
  }, [data]);
  const handleButtonClick = async () => {
    try {
      const payload = {
        user: {
          email: employee.email,
          password: employee.password,
          firstname: employee.firstName,
          lastname: employee.lastName,
          phone: employee.phone,
        },
        doj: employee.doj,
        dob: employee.dob,
        gender: employee.gender.id,
        emp_id: employee.emp_id,
        role: employee.role,
        designation: employee.designation,
        permissions: employee.permissions,
        org: user.org_id,
      };

      const res = await ApiCalls.createEmployee(payload, false);
      if (res.success && res.code === 201) {
        navigate("/employee/employees");
      } else {
      }
    } catch (error) {
      console.error(error);
    }
  };

  const labels = {
    left: {
      title: "Deactive",
      value: "deactive",
    },
    right: {
      title: "Notice",
      value: "notish",
    },
    center: {
      title: "Active",
      value: "active",
    },
  };

	const fileInputRef = useRef(null);
	const handleFileSelect = async (e) => {
		const file = e.target.files[0];
		// const base64Data = await convertToBase64(file);
		setSelectedImage(URL.createObjectURL(file));
		updateProfile(file);
	};

	 const updateProfile = async (file) => {
        try {
          const formData = new FormData();
          formData.append("img", file);
    
    
    
          const res = await ApiCalls.editEmployee(user_id, formData, true);
    
          if (res.success && res.code === 200) {
            setProfileImage(formData.img);
    
            // location.pathname == "/pages/profile/profile-overview"
            //   ? null
            //   : navigate("/dashboards/employees");
          } else {
          }
        } catch (error) {
          console.error(error);
        }
      };

      const handleEditClick = () => {
        fileInputRef.current.click();
    
      };

  return (
    <>
      {!isCreateEmployee ? (
        <DashboardLayout>
          <DashboardNavbar></DashboardNavbar>
					<MDBox mt={2}>
						<Grid container spacing={2.5} alignItems="flex-start">
							{/*<Grid item xs={12} lg={4}>
                <Details
                  data={data}
                  permissions={permission}
                  modulePermissions={modulePermissions}
                  labels={labels}
                  user_id={user_id}
                  reloadCallback={() => {
                    getEmployee();
                  }}
                />
              </Grid>*/}

							<Grid item xs={12}>
								{/*<Card
                  sx={{
                    p: { xs: 1.25, md: 1.5 },
                    borderRadius: "30px",
                    border: `1px solid ${rgba(colors.secondary.main, 0.1)}`,
                    boxShadow: `0 18px 42px ${rgba(colors.dark.main, 0.06)}`,
                    //backgroundColor: rgba(colors.white.main, 0.92),
                  }}
                >*/}
								<MDBox
									sx={{
										p: { xs: 2, md: 2.75 },
										minHeight: { xs: 220, md: 260 },
										borderRadius: "26px",
										position: "relative",
										overflow: "hidden",
										background: `linear-gradient(135deg, ${rgba(colors.primary.main, 0.98)} 0%, ${rgba(colors.info.focus, 0.95)} 55%, ${rgba(colors.info.main, 0.88)} 100%)`,
										border: `1px solid ${rgba(colors.info.main, 0.1)}`,
										boxShadow: `0 18px 42px ${rgba(colors.dark.main, 0.08)}`,
										"&::before": {
											content: '""',
											position: "absolute",
											inset: 0,
											background:
												"radial-gradient(circle at top right, rgba(255,255,255,0.18), transparent 34%)",
											pointerEvents: "none",
										},
									}}
								>
									<Grid container spacing={2.5} alignItems="center">
										<Grid item xs={12}>
											<Stack
												direction={{ xs: "column", md: "row" }}
												spacing={2.5}
												alignItems={{ xs: "flex-start", md: "center" }}
												justifyContent="space-between"
												sx={{ position: "relative", zIndex: 1 }}
											>
												<Stack
													//direction={{ xs: "column", sm: "row" }}
													spacing={2}
													display="flex"
													flexDirection='column'
												//alignItems={{ xs: "flex-start", sm: "center" }}
												>
													<MDBox display="flex" gap={2}>
														<MDBox
															sx={{
																width: 48,
																height: 48,
																borderRadius: "16px",
																display: "grid",
																placeItems: "center",
																background: `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.info.main} 100%)`,
																color: colors.white.main,
															}}
														>
															<AccountCircle />
														</MDBox>
														<MDBox sx={{ display: "flex", flexDirection: "column" }}>
															<MDTypography
																variant="h3"
																sx={{ color: "White", letterSpacing: "-0.03em" }}
															>
																{`${data?.user?.firstname || ""} ${data?.user?.lastname || ""}`.trim()}
															</MDTypography>
														</MDBox>
													</MDBox>
													<MDBox sx={{display : "flex", flexDirection: "column"}}>
														<Stack
															direction={{ xs: "column", sm: "row" }}
															spacing={2}
															mt={1.6}
															alignItems={{ xs: "flex-start", sm: "center" }}
														>
															<MDBox
																sx={{
																	px: 1.7,
																	py: 0.65,
																	borderRadius: "999px",
																	backgroundColor:
																		data?.status === "active"
																			? rgba(colors.success.main, 0.22)
																			: rgba(colors.warning.main, 0.22),
																	color: colors.white.main,
																	fontSize: "0.75rem",
																	fontWeight: 700,
																	textTransform: "capitalize",
																}}
															>
																{data?.status || "active"}
															</MDBox>
																													
                            <MDTypography
															variant="h6"
															sx={{ color: colors.info.light, mt: 0.4 }}
														>
															{data?.designation?.name || "Employee"} 
														</MDTypography>
															<Stack direction="row" spacing={0.7} alignItems="center">
																<PlaceOutlined sx={{ color: colors.white.main, fontSize: 18 }} />
																<MDTypography
																	variant="button"
																	sx={{ color: rgba(colors.white.main, 0.82) }}
																>
																	{currentBranchName}
																</MDTypography>
															</Stack>
														</Stack>

														<Stack
															direction={{ xs: "column", sm: "row" }}
															spacing={2}
															mt={1.6}
															alignItems={{ xs: "flex-start", sm: "center" }}
														>
															<Stack direction="row" spacing={0.7} alignItems="center">
																<Phone sx={{ color: colors.white.main, fontSize: 18 }} />
																<MDTypography
																	variant="button"
																	sx={{ color: rgba(colors.white.main, 0.82) }}
																>
																	{data?.user?.phone || "" }
																</MDTypography>
															</Stack>
															<Stack direction="row" spacing={0.7} alignItems="center">
																<Email sx={{ color: colors.white.main, fontSize: 18 }} />
																<MDTypography
																	variant="button"
																	sx={{ color: rgba(colors.white.main, 0.82) }}
																>
																	{data?.user?.email || "" }
																</MDTypography>
															</Stack>
															<MDBox
																sx={{
																	px: 1.7,
																	py: 0.65,
																	borderRadius: "999px",
																	backgroundColor:
																		data?.status === "active"
																			? rgba(colors.success.main, 0.22)
																			: rgba(colors.warning.main, 0.22),
																	color: colors.white.main,
																	fontSize: "0.75rem",
																	fontWeight: 700,
																	textTransform: "capitalize",
																}}
															>
																GE - {data?.emp_id || "Not available"}
															</MDBox>
														</Stack>
													</MDBox>
												</Stack>

												<Stack
													spacing={1.2}
													alignItems={{ xs: "flex-start", md: "flex-end" }}
													width={{ xs: "100%", md: "auto" }}
												>
													<MDBox
														sx={{
															p: 0.8,
															borderRadius: "24px",
															backgroundColor: rgba(colors.white.main, 0.08),
															backdropFilter: "blur(10px)",
														}}
													>
														<MDAvatar
															src={normalizeImage(data?.img)}
															alt={data?.user?.firstname || "Employee"}
															size='lg'
															sx={{
																width: { xs: 108, md: 190 },
																height: { xs: 150, md: 200 },
																border: `3px solid ${rgba(colors.white.main, 0.9)}`,
																boxShadow: `0 14px 28px ${rgba(colors.dark.main, 0.16)}`,
																borderRadius: "22px",
															}}
															
														/>
															<input
																type="file"
																ref={fileInputRef}
																style={{ display: "none" }}
															  onChange={handleFileSelect}
															/>
															{permissions?.includes(modulePermissions?.update_permission) && <IconButton
																  onClick={() => {
																handleEditClick();
																  }}
																size="small"
																sx={{
																	position: "absolute",
																	top: 8,
																	right: 8,
																	backgroundColor: "White",
																	boxShadow: 2,
																	"&:hover": {
																		backgroundColor: "#f0f0f0",
																	},
																}}
															>
																<Edit fontSize="small" />

															</IconButton>}
														{/*</MDAvatar>*/}
														{/*<Avatar
															src={data?.img}
															variant="square"
															style={{
																height: "auto",
																width: "100%",
																borderRadius: "16px",
															}}
														/>
														<input
															type="file"
															//ref={fileInputRef}
															style={{ display: "none" }}
														//onChange={handleFileSelect}
														/>
          {permissions?.includes(modulePermissions?.update_permission) && <IconButton
            //  onClick={() => {
            //handleEditClick();
            //  }}
              size="small"
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                backgroundColor: "White",
                boxShadow: 2,
                "&:hover": {
                  backgroundColor: "#f0f0f0",
                },
              }}
            >
              <Edit fontSize="small" />
              
            </IconButton>}*/}
													</MDBox>
												</Stack>
											</Stack>
										</Grid>

										{/*<Grid item xs={12} md={5}>
                        <Stack
                          direction={{ xs: "column", sm: "row" }}
                          spacing={1}
                          justifyContent={{ md: "flex-end" }}
                        >
                          <MDButton
                            component="a"
                            href="#basic-info"
                            variant="outlined"
                            color="dark"
                            sx={{ borderRadius: "12px" }}
                          >
                            Edit Info
                          </MDButton>
                          <MDButton
                            component="a"
                            href="#managers"
                            variant="gradient"
                            color="info"
                            sx={{ borderRadius: "12px" }}
                          >
                            View Team
                          </MDButton>
                        </Stack>
                      </Grid>*/}
									</Grid>
								</MDBox>

								<MDBox mt={2.5}>
									<BaseLayout tabComponents={tabComponents}/>
										{/*<Footer />*/}
								</MDBox>
								{/*</Card>*/}
							</Grid>
						</Grid>
					</MDBox>
        </DashboardLayout>
      ) : (
        <DashboardLayout>
          <DashboardNavbar></DashboardNavbar>
          <MDBox mt={5}>
            <MDBox mb={3}>
              <MDBox mb={3}>
                <BasicInfo
                  data={data}
                  isCreateEmployee={isCreateEmployee}
                  Employee={employee}
                  setEmployee={setEmployee}
                  reloadCallback = {()=>{
                    getEmployee()
                  }}
                />
              </MDBox>
              {!isCreateEmployee && <ChangePassword data={data} />}
              <Permissions
                data={data}
                isCreateEmployee={isCreateEmployee}
                Employee={employee}
                setEmployee={setEmployee}
              />

              {isCreateEmployee && (
                <MDBox display="flex" justifyContent="center" p={2}>
                  <MDButton
                    variant="gradient"
                    color="dark"
                    onClick={() => {
                      handleButtonClick();
                    }}
                  >
                    Create Employee
                  </MDButton>
                </MDBox>
              )}
            </MDBox>
          </MDBox>
        </DashboardLayout>
      )}
    </>
  );
}

export default EmployeeView;
